import { Get, Post, Delete } from "api";
import {
  GameNetworkExclusion,
  CreateGameNetworkExclusionRequest,
  Platform,
} from "views/admin/gameNetworkExclusions/types";
import { getPartners } from "views/admin/partners/services";
import { Partner } from "redux/partners/reducer";

export async function getGameNetworkExclusions(): Promise<{
  data: GameNetworkExclusion[];
  total: number;
}> {
  try {
    const response = await Get("/manage/game-network-exclusions");

    if (response && Array.isArray(response)) {
      return {
        data: response,
        total: response.length,
      };
    }

    return {
      data: [],
      total: 0,
    };
  } catch (error) {
    console.error("Error fetching game network exclusions:", error);
    return {
      data: [],
      total: 0,
    };
  }
}

export async function createGameNetworkExclusion(
  data: CreateGameNetworkExclusionRequest
) {
  try {
    if (!data.platformId) {
      throw new Error("Please select a platform");
    }

    const trimmedNetwork = data.network?.trim();
    if (!trimmedNetwork) {
      throw new Error("Please enter a network name");
    }

    const requestData = {
      partnerId: data.partnerId || null,
      platformId: data.platformId,
      packageName: data.packageName?.trim() || null,
      network: trimmedNetwork,
    };

    const response = await Post("/manage/game-network-exclusions", requestData);

    if (response?.error) {
      throw new Error(response.error);
    }

    return response;
  } catch (error: any) {
    console.error("Error creating game network exclusion:", error);
    throw error;
  }
}

export async function deleteGameNetworkExclusion(exclusionId: number) {
  try {
    await Delete(`/manage/game-network-exclusions/${exclusionId}`);
    return { success: true };
  } catch (error: any) {
    console.error("Error deleting game network exclusion:", error);
    throw error;
  }
}

export const getPartnersData = async (): Promise<{
  data: Partner[];
  total: number;
}> => {
  try {
    const response = await getPartners({
      page: 1,
      pageSize: 1000,
      filters: {
        hasAtLeastOneCampaign: true,
      },
    });

    return {
      data: response.data ?? [],
      total: response.total,
    };
  } catch (error) {
    console.error("Error fetching partners:", error);
    return {
      data: [],
      total: 0,
    };
  }
};

export const getPlatforms = (): Platform[] => {
  return [
    { id: 1, name: "iOS" },
    { id: 2, name: "Android" },
  ];
};
